import { render, staticRenderFns } from "./UserJiameng.vue?vue&type=template&id=190536b8&scoped=true&"
import script from "./UserJiameng.vue?vue&type=script&lang=js&"
export * from "./UserJiameng.vue?vue&type=script&lang=js&"
import style0 from "./UserJiameng.vue?vue&type=style&index=0&id=190536b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "190536b8",
  null
  
)

export default component.exports